import Button from "@components/Button";
import Script from "next/script";
import { useRef, useState } from "react";
import style from "./openTableComponent.module.scss"
import { gaEvent } from "@lib/ga";

// This version of open table is jsut a button that links to the open table widget. it was created to avoid all of the ifram issues we had.



const OpenTableComponentNew = () => {

    const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);
    const modalRef = useRef(null);

    return (
        <>
            <div style={{ display: scriptLoaded ? 'none' : 'inline-block' }}>
                <Button
                    link={{
                        text: "MAKE A RESERVATION",
                        url: "https://www.opentable.com.au/r/warrior-restaurant-and-bar-reservations-beerwah?restref=171431&lang=en-AU&ot_source=Restaurant%20website"
                    }}
                    type={"a"}
                    click={() => {
                        gaEvent('reservation_click');
                    }}
                    target_blank={true}
                />
            </div>
            <div ref={modalRef} id={'openWidgetModal'} />
            {
                /*
            
            <Script 
            async={true}
            type='text/javascript' 
            src='//www.opentable.com.au/widget/reservation/loader?rid=171431&type=standard&theme=tall&color=2&dark=true&iframe=true&domain=comau&lang=en-AU&newtab=false&ot_source=Restaurant%20website'
            strategy="lazyOnload"
            onLoad={() => {
                const pollDOM = () => {
                    const el = document.querySelector('[id^=ot-widget-container]');

                    if (el !== null) {
                        modalRef.current!.appendChild(el);
                        setScriptLoaded(true);
                    } else {
                        setTimeout(pollDOM, 300); // try again in 300 milliseconds
                    }
                }
                pollDOM();
            }}
        /> */}
        </>
    )
}

export default OpenTableComponentNew;